import request from '@/utils/request';

export const faultList = (params: any) =>
  request({
    url: 'Fault/faultList',
    method: 'GET',
    params
  });
export const deleteFault = (data: any) =>
  request({
    url: 'Fault/fault',
    method: 'DELETE',
    data
  });
export const deleteFaultAll = (data: any) =>
  request({
    url: 'Fault/deleteFaultAll',
    method: 'DELETE',
    data
  });
export const importFault = (data: any) =>
  request({
    url: 'Fault/importFault',
    method: 'POST',
    data
  });
export const importFaultPhenomenon = (data:any) =>
  request({
    url: 'Fault/importFaultPhenomenon',
    method: 'POST',
    data
  });
export const addFault = (data: any) =>
  request({
    url: 'Fault/fault',
    method: 'POST',
    data
  });
export const editFault = (data: any) =>
  request({
    url: 'Fault/fault',
    method: 'PUT',
    data
  });
